import Field from "../common/field";

export default class FootballField extends Field {
    constructor() {
        super();
        this.yards = 100;
    }
}
